document.addEventListener('turbo:load', function(e) {
  
});
